import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Headers, RequestOptions, Http } from '@angular/http';
import { ProductSearchResponse } from './../sheared/entities/productSearchResponse';

@Injectable()
export class ProductSearchService {

    constructor(private http: Http) {
    }

    getFiltered(filter: string): Observable<any> {
      let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
      let body = 'filter=' + filter;
      return this.http.post("/SearcherService.asmx/Products", body, { headers: headers }).map(function (res)
      {
        var data = res.text();
        var jsonData = data.substring(data.indexOf('>') + 1, data.lastIndexOf('<')).substring(data.indexOf('>') + 1);;
        var result = new Array<ProductSearchResponse[]>();
        result = JSON.parse(jsonData);
        return result;
      });
    }
}



// WEBPACK FOOTER //
// C:/websites/emusic-search-WA/emusic2018/emusic2018/SPA/src/app/services/productSearch.service.ts